import { render, staticRenderFns } from "./VsLayout.vue?vue&type=template&id=5a87c9a4&lang=pug&"
import script from "./VsLayout.vue?vue&type=script&lang=js&"
export * from "./VsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a87c9a4')) {
      api.createRecord('5a87c9a4', component.options)
    } else {
      api.reload('5a87c9a4', component.options)
    }
    module.hot.accept("./VsLayout.vue?vue&type=template&id=5a87c9a4&lang=pug&", function () {
      api.rerender('5a87c9a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsLayout.vue"
export default component.exports